import React from 'react';
import {ButtonBase} from '@mui/material';
import PropTypes from 'prop-types';

export const RedirectToCandidateButtonComponent = ({redirectLink}) => (
  <>
    <ButtonBase
      onClick={(e) => {
        e.stopPropagation();
        window.open(redirectLink, '_blank');
      }}
      className="btns-icon theme-transparent  px-2 miw-0 "
    >
      {' '}
      <span className="mdi mdi-eye-circle gray-medium-light-color" />
    </ButtonBase>
  </>
);

RedirectToCandidateButtonComponent.propTypes = {
  redirectLink: PropTypes.string.isRequired
};
